export const baseTinyInit = {
    height: 300,
    menubar: false,
    plugins: [
        "advlist", "autolink", "lists", "link", "image", "charmap",
        "preview", "anchor", "searchreplace", "visualblocks", "code",
        "fullscreen", "insertdatetime", "media", "table", "code",
        "help", "wordcount"
    ],
    toolbar:
        "fullscreen | undo redo pasteFromClipboard | formatselect | bold italic backcolor | " +
        "alignleft aligncenter alignright alignjustify | " +
        "bullist numlist outdent indent | removeformat | help",
    contextmenu: "pasteFromClipboard | link image table",
    
}